import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrivyProvider } from '@privy-io/react-auth';
import { toSolanaWalletConnectors } from '@privy-io/react-auth/solana';
import './index.css'; // Design tokens (CSS custom properties)
import './styles.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { initSentry } from './observability/sentry';
import { installWalletRuntimeGuards } from './wallets/walletRuntimeGuards';
import { buildPrivyEvmChains, buildPrivyRpcConfig, getPrivyDefaultChain } from './privyConfig';
import { isChainEnabled } from './chains/registry';
import { CHAIN_KEYS } from './chains/interfaces';

const root = ReactDOM.createRoot(document.getElementById('root'));
const privyAppId = process.env.REACT_APP_PRIVY_APP_ID || '';
const solanaEnabled = isChainEnabled(CHAIN_KEYS.SOLANA);
const solanaConnectors = solanaEnabled
  ? toSolanaWalletConnectors({ shouldAutoConnect: false })
  : undefined;

const evmPrivyChains = buildPrivyEvmChains();
const privyRpcConfig = buildPrivyRpcConfig();
const privyDefaultChain = getPrivyDefaultChain({ privyChains: evmPrivyChains });

if (!privyAppId) {
  // Privy owns wallet discovery and connection. Missing configuration should
  // be visible during smoke testing instead of silently falling back to a vendor.
  console.error('REACT_APP_PRIVY_APP_ID is required for wallet connections.');
}

installWalletRuntimeGuards();
initSentry();

root.render(
  <ErrorBoundary>
    <PrivyProvider
      appId={privyAppId}
      config={{
        loginMethods: ['wallet'],
        supportedChains: evmPrivyChains,
        defaultChain: privyDefaultChain,
        rpcConfig: privyRpcConfig,
        appearance: {
          showWalletLoginFirst: true,
          walletChainType: solanaEnabled ? 'ethereum-and-solana' : 'ethereum-only',
        },
        ...(solanaEnabled ? { externalWallets: { solana: { connectors: solanaConnectors } } } : {}),
      }}
    >
      <App />
    </PrivyProvider>
  </ErrorBoundary>
);
